<template>
    <div>
        <Form :model="detailForm" :label-width="80" :rules="detailRules" ref="detailForm">
            <!--<FormItem prop="stuNo" label="学号">-->
            <!--<Input type="text" v-model="detailForm.stuNo" placeholder="学号" :readonly="readonly" style="width:300px;"/>-->
            <!--</FormItem>-->
            <FormItem prop="name" label="姓名">
                <Input type="text" v-model="detailForm.name" placeholder="姓名" style="width:300px;"/>
            </FormItem>
            <FormItem prop="stu_no" label="学号">
                <Input type="text" v-model="detailForm.stu_no" placeholder="--系统自动生成--" style="width:300px;"
                       readonly="readonly"/>
            </FormItem>
            <FormItem prop="sex" label="性别">
                <RadioGroup v-model="detailForm.sex">
                    <Radio :label="1">男</Radio>
                    <Radio :label="2">女</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem prop="birthday" label="生日">
                <DatePicker type="date" placeholder="选择日期"
                            v-model="detailForm.birthday" style="width:300px;"></DatePicker>
            </FormItem>
            <FormItem prop="zone_id" label="校区">
                <Select v-model="detailForm.zone_id" :disabled="readonly" style="width:300px;">
                    <Option v-for="(item,index) in zoneList" :key="index" :value="item.id">{{item.name}}
                    </Option>
                </Select>
            </FormItem>
            <FormItem prop="remark" label="备注">
                <Input v-model="detailForm.remark" placeholder="备注" style="width:300px;" type="textarea" :rows="4"  />
            </FormItem>
            <FormItem>
                <Button type="primary" size="small" @click="saveDetail('detailForm')">保存</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
    export default {
        name: 'detail',
        data() {
            return {
                readonly: false,
                detailForm: {
                    id: null,
                    name: null,
                    stu_no: null,
                    sex: 1,
                    birthday: null,
                    zone_id: null,
                    remark:null
                },
                zoneList: [],
                detailRules: {
                    name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                    zone_id: [{required: true, message: '请选择校区', trigger: 'change', type: 'number'}]
                }
            }
        },
        methods: {
            init() {
                this.detailForm.id = null
                this.$refs.detailForm.resetFields()
                this.getZoneList();
            },
            getZoneList() {
                this.zoneList = [];
                this.$api.zone.getAll().then(res => {
                    if (res.state == "ok") {
                        this.zoneList = res.data
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getStudentDetail() {
                this.$api.student.getStudentDetail({id: this.detailForm.id}).then(res => {
                    if (res.state == "ok") {
                        this.detailForm = res.detail;
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            packagingFormData() {
                let postFormData = {};
                for (var i in this.detailForm) {
                    if (this.detailForm.hasOwnProperty(i)) {
                        if (i == "birthday") {
                            this.detailForm[i] = this.$api.student.getDateFormat(this.detailForm[i])
                        }
                        if (i == "zone_name") {
                            continue;
                        }
                        postFormData['student.' + i] = this.detailForm[i];
                    }
                }
                return postFormData;
            },
            saveDetail(name) {
                let self = this
                self.$refs[name].validate((valid) => {
                    if (valid) {
                        // if (this.detailForm.stuNo == '' || this.detailForm.stuNo == null) {
                        //   this.$Message.error("请填写学生学号")
                        // } else {
                        self.$api.student.saveDetail(this.packagingFormData()).then(res => {
                            if (res.state == "ok") {
                                self.$Message.success("保存成功")
                                if (res.id != 0) {
                                    self.$store.commit('closeTag', {
                                        name: 'student_detail'
                                    });
                                    // self.$router.push({
                                    //   name: 'student_index'
                                    // })
                                }
                            } else {
                                self.$Message.error(res.msg)
                            }
                        })
                        // }
                    } else {
                        self.$Message.error("表单验证不通过");
                    }
                })
            },
        }
    }
</script>
